import {
  SET_CABANG_DATA,
  SET_ACTIVE_CABANG_PAGINATION,
  SET_CABANG_PAGINATION,
  SET_CABANG_KEYWORD,
  LOAD_DATA_CABANG,
} from '../../@jumbo/constants/ActionTypes';

const INIT_STATE = {
  cabangData: [],
  activePaginate: 1,
  pagination: {
    current_page: 0,
    per_page: 0,
    total: 0,
    last_page: 0,
    from: 0,
  },
  keyword: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_CABANG_DATA: {
      return {
        ...state,
        cabangData: action.payload,
      };
    }
    case SET_CABANG_PAGINATION: {
      return {
        ...state,
        pagination: action.payload,
      };
    }
    case SET_ACTIVE_CABANG_PAGINATION: {
      return {
        ...state,
        activePaginate: action.payload,
      };
    }
    case SET_CABANG_KEYWORD: {
      return {
        ...state,
        keyword: action.payload,
      };
    }
    default:
      return state;
  }
};
